import React from 'react'
import { Box } from 'chemistry'

const DeliveryModeLabel = ({ deliveryMode, position = 'right' }) => {
  if (!deliveryMode) return null

  return (
    <Box
      display='inline-block'
      p='8px 16px'
      backgroundColor='black'
      color='var(--chakra-colors-white-0)'
      lineHeight='1.5714285714'
      fontFamily='RubrikNew-Bold,Ubuntu,sans-serif'
      letterSpacing='.1px'
      textTransform='uppercase'
      position='absolute'
      right={position === 'left' ? 'auto' : 'var(--promotion-label-margin)'}
      bottom='calc(106px + var(--promotion-label-margin))'
      zIndex={5}
      left={position === 'left' ? 'var(--promotion-label-margin)' : undefined}
    >
      {deliveryMode}
    </Box>
  )
}

export default DeliveryModeLabel
